import {groupAccessLocations} from '@/modules/locations/functions'
import {useGetUserCredentialAccount} from '@/modules/users/api'
import {DataList} from '@cypro/ui/components/ui/data-list'
import {DataSection} from '@cypro/ui/components/ui/data-section'
import {UserTag} from '@/shared/components/ui/tags/user-tag'
import {useUserContext} from '@/shared/contexts'
import {getDatetimeFormatter} from '@cypro/ui/utils'
import {Badge, HStack, Tabs} from '@chakra-ui/react'
import {useTranslate} from '@tolgee/react'
import {useMemo} from 'react'

export function AboutTab() {
  const {t} = useTranslate('common')
  const {user, session} = useUserContext()
  const [account] = useGetUserCredentialAccount(user.id)

  const aboutItems = useMemo(() => {
    return [
      {label: t('user_id'), value: user.id},
      {label: t('last_login'), value: session?.createdAt ? getDatetimeFormatter().format(session.createdAt) : ''},
      {label: t('email'), value: user.email},
      {label: t('created_by'), value: user.created ? <UserTag user={user.created} /> : ''},
      {label: t('date'), value: user.createdAt ? getDatetimeFormatter().format(user.createdAt) : ''},
    ]
  }, [t, user, session])

  const organizationItems = useMemo(() => {
    const groupedLocations = groupAccessLocations(user.userAccessLocations || [])
    const [location] = groupedLocations

    return [
      {label: t('organization'), value: location?.name},
      {
        label: t('section'),
        value: location?.sections ? (
          <HStack flexWrap="wrap">
            {location?.sections?.map(s => (
              <Badge key={s.id} size="sm">
                {s.name}
              </Badge>
            ))}
          </HStack>
        ) : null,
      },
      {
        label: t('wards'),
        value: location?.sections ? (
          <HStack flexWrap="wrap">
            {location?.sections?.flatMap(s =>
              s.wards.map(w => (
                <Badge key={w.id} size="sm">
                  {w.name}
                </Badge>
              ))
            )}
          </HStack>
        ) : null,
      },
    ]
  }, [t, user])

  return (
    <Tabs.Content value="about" spaceY="8" display="flex" flexDirection="column">
      <DataSection label={t('about')}>
        <DataList items={aboutItems} />
      </DataSection>

      <DataSection label={t('organization_details')}>
        <DataList items={organizationItems} />
      </DataSection>

      <DataSection label={t('security')}>
        <DataList
          items={[
            {
              label: t('last_password_reset'),
              value: account?.passwordSetAt ? getDatetimeFormatter().format(new Date(account.passwordSetAt)) : null,
            },
          ]}
        />
      </DataSection>
    </Tabs.Content>
  )
}
